<template>
  <div class="position-relative benefit-banner overflow-hidden">
    <lazy-image
      class="benefit-banner_bg"
      cover_img
      :src="img_src"
      :lazy_src="lazy_img_src"
      alt="banner image"
    />
    <div class="container position-relative benefit-banner_content">
      <default-title
        class="benefit-banner_title"
        :title_tag="title_tag"
        :title="title"
        white
      />
      <component
        :is="getIsMobile ? 'swiper' : 'div'"
        class="benefit-banner__row"
        v-bind="component_params">
        <swiper-slide
          v-for="(benefit, index) in benefits"
          :class="getIsMobile ? 'col-12' : 'col-sm-4'"
          :class_swiper_slide="getIsMobile"
          :key="`swiper-slide_${index}_${uid}`">
          <div class="benefit-banner__item">
            <check-mark class="mr-15"/>
            {{benefit.text}}
          </div>
        </swiper-slide>
      </component>
    </div>
  </div>
</template>

<script>
import HtmlBlock from "../small_parts/HtmlBlock";
import LazyImage from "../small_parts/LazyImage.vue";
import DefaultTitle from "../small_parts/DefaultTitle.vue";
import CheckMark from "../small_parts/CheckMark.vue";
import SwiperSlide from "../modules/Swiper/SwiperSlide.vue";
import {mapGetters} from "vuex";
import uid_mixin from "../../mixins/uid_mixin";
import Swiper from "../modules/Swiper/Swiper.vue";

export default {
  name: "BenefitBanner",
  mixins: [uid_mixin],
  components: {
    Swiper,
    SwiperSlide,
    CheckMark,
    DefaultTitle,
    LazyImage,
    HtmlBlock
  },
  props: {
    /**props**/
    img_src: {
      type: String,
      default: '',
      admin_type: 'image',
    },
    lazy_img_src: {
      type: String,
      default: '',
      admin_type: 'image',
    },
    title: {
      type: String,
      default: '',
      admin_type: 'input',
    },
    title_tag: {
      type: String,
      default: 'h1',
      admin_type: 'select',
      admin_data_values: [
        'h1', 'h2', 'h3', 'h4', 'h5', 'h6'
      ],
    },
    benefits: {
      type: Array,
      default: () => [],
      admin_type: 'array',
      array_values: {
        text: {
          type: String,
          default: '',
          admin_type: 'textarea',
        },
      }
    },
    /**props**/
  },
  computed: {
    ...mapGetters([
      'getIsMobile'
    ]),
    component_params() {
      if (!this.getIsMobile) {
        return {
          class: 'row'
        }
      }
      return {
        class: 'position-relative',
        add_navigation_buttons: true,
        next_btn_class: 'benefit-banner_next_btn',
        prev_btn_class: 'benefit-banner_prev_btn',
        swiper_config: {
          spaceBetween: 20
        },
      }
    }
  }
}
</script>
